import { Brand, createBranded } from '@deltasierra/type-utilities';

export type EmailTemplateContentValueId = Brand<string, 'EmailTemplateContentValueId'>;
export const EmailTemplateContentValueId = createBranded<EmailTemplateContentValueId>();
